// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__3cUtM","label":"Category_label__37tvM","content":"Category_content__221nv","header":"Category_header__l7arD","location":"Category_location__2O9Jq"};